import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  EngagementPaymentReasons,
  EngagementsService,
  paymentReasonsList,
} from '@techspert-io/engagements';
import { IPaymentDashboardEngagement } from '../payments-models';

@Component({
  selector: 'app-notes-dialog',
  templateUrl: './notes-dialog.component.html',
  styleUrls: ['./notes-dialog.component.scss'],
  standalone: false,
})
export class NotesDialogComponent {
  public engagement: IPaymentDashboardEngagement;
  public paymentReasons: EngagementPaymentReasons[] = paymentReasonsList;

  constructor(
    public dialogRef: MatDialogRef<NotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      engagement: IPaymentDashboardEngagement;
      disableTransactionId: boolean;
    },
    private engagementsService: EngagementsService
  ) {
    this.engagement = this.data.engagement;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public saveChanges(): void {
    this.engagementsService
      .updateLegacy({
        engagementId: this.engagement.engagementId,
        notes: this.engagement.notes,
        ...(!this.data.disableTransactionId && {
          transactionId: this.engagement.transactionId,
        }),
        ...(this.engagement.engagementType === 'payment'
          ? { reason: this.engagement.reason }
          : {}),
      })
      .subscribe(() => {
        this.closeDialog();
      });
  }
}
